// Thin client for the Slack integration backend endpoints.
//
// All endpoints are mounted under /api/integrations/slack — see backend
// `slack_service.py`. These helpers swallow nothing; callers decide how to
// toast / banner errors so we can keep behaviour consistent across pages.

const API = `${process.env.REACT_APP_BACKEND_URL}/api/integrations/slack`;

async function json(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || `Slack request failed (${res.status})`);
  return data;
}

export async function getSlackStatus() {
  return json(await fetch(`${API}/status`));
}

export async function getSlackSettings() {
  return json(await fetch(`${API}/settings`));
}

// Build the lean serialisable payload Slack needs from a frontend deal
// object. Resolves brand names since we ship them as IDs in mock data.
export function dealToSlackPayload(deal, brandsById) {
  const brandIds = deal.isMultiBrand ? (deal.brandIds || []) : [deal.brandId].filter(Boolean);
  const brandNames = brandIds.map((id) => brandsById?.[id]?.name).filter(Boolean);
  return {
    id:          deal.id,
    name:        deal.name,
    rate:        deal.rate,
    capTotal:    deal.capTotal,
    capUsed:     deal.capUsed,
    deadline:    deal.deadline,
    whyBuying:   deal.whyBuying,
    brandNames,
    brandName:   brandNames[0] || null,
  };
}

export async function publishDealToSlack(deal, brandsById, channelId = null) {
  return json(await fetch(`${API}/publish-deal`, {
    method:  "POST",
    headers: { "Content-Type": "application/json" },
    body:    JSON.stringify({
      deal:       dealToSlackPayload(deal, brandsById),
      channel_id: channelId || undefined,
    }),
  }));
}
